export default {
  sections: [
    {
      id: 'NotFound',
      name: 'NotFoundSection',
    },
  ],
};
